import script from "./ViewSpecifications.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewSpecifications.vue?vue&type=script&setup=true&lang=js"

import "./ViewSpecifications.vue?vue&type=style&index=0&id=711557c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-711557c6"]])

export default __exports__